const StringValidator = require('./StringValidator')
const ObjectValidator = require('./ObjectValidator')
const LuhnValidator = require('./LuhnValidator')
const PostalCodeValidator = require('./PostalCodeValidator')
const NumberValidator = require('./NumberValidator')
const ArrayValidator = require('./ArrayValidator')
const BooleanValidator = require('./BooleanValidator')
class Validator {
  /**
   * @param {string} argument
   * @param {string} argumentName The name of the argument that will be used in error logging
   * @param {StringOptions} [options]
   * @property {number} options.minLength
   * @property {number} options.maxLength
   * @property {string} options.format - Checks for one of supported formats: [ email, uuid ]
   */

  static validateString(argument, argumentName, options) {
    return StringValidator.validate(argument, argumentName, options)
  }

  static validateObject(argument, argumentName) {
    return ObjectValidator.validate(argument, argumentName)
  }

  static validateNumber(argument, argumentName, options) {
    return NumberValidator.validate(argument, argumentName, options)
  }

  static validateCard(argument, argumentName) {
    // use the default options for the LuhnValidator with cards
    return LuhnValidator.validate(argument, argumentName)
  }

  /**
   * validates a postal code using the regex for the passed country
   * @param {string} argument
   * @param {string} argumentCountry The country of the argument
   * @param {string} argumentName The name of the argument that will be used in error logging
   */
  static validatePostalCode(argument, argumentCountry, argumentName) {
    return PostalCodeValidator.validate(argument, argumentCountry, argumentName)
  }

  static validateArray(argument, argumentName) {
    return ArrayValidator.validate(argument, argumentName)
  }

  static validateBoolean(argument, argumentName) {
    return BooleanValidator.validate(argument, argumentName)
  }
}

module.exports = Validator
